import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { SetorContaInadimplencia } from "core/features/relatorios/typings";

const { Option } = Select;

export interface SelectSetorCobrancaProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectSetorCobranca({ value, ...rest }: SelectSetorCobrancaProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option
        value={SetorContaInadimplencia.Administrativo}
        key={SetorContaInadimplencia.Administrativo}
      >
        Administrativo
      </Option>
      <Option
        value={SetorContaInadimplencia.Juridico}
        key={SetorContaInadimplencia.Juridico}
      >
        Jurídico
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectSetorCobranca;
